export default class DocumentTypeModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.description = obj.description;
    this.additionalInfo = obj.additionalInfo;
  }
}